export default __webpack_public_path__ + "37a59ac2ff1d1143db72e2b72faa6ee3.png";